import { ArrayContactorForm } from './ArrayContactorForm'
import { ArrayContactorResults } from './ArrayContactorResults'
import CommandModalTemplate from '../CommandModalTemplate'
import { useParams } from 'react-router-dom'
import { useSiteControllerVersionContext } from 'contexts/siteControllerVersionContext'
import ContactorState from 'api/types/ContactorState'
import EnablementState from 'api/types/EnablementState'

// 1st modal, 2nd modal heading
const modalTitles = {
  start: 'Set Contactors',
  finish: 'Contactor State',
}

// step 1: define custom input. form returns jsx
const userInputFormJsx = ({ ids, userInputForm, setUserInputForm }) =>
  ArrayContactorForm({ ids, userInputForm, setUserInputForm })

// step 2: custom CommandResultsTemplate.jsx
const commandResultJsx = ({ ids, userInputForm }) => {
  return <ArrayContactorResults ids={ids} userInputForm={userInputForm} />
}

// SetCommandModal keeps track of input form and each modal step, sending command, close modal
export const SetArrayContactorModal = ({ setShowCommandModal, ids }) => {
  const { stationCode } = useParams()
  const { isOpModel2 } = useSiteControllerVersionContext()
  // set up initial form values
  const defaultFormValues = {
    contactorState: ContactorState.OPEN,
    ignoreHighCellGroupVoltageAlarm: EnablementState.DISABLED,
    ignoreLowCellGroupVoltageAlarm: EnablementState.DISABLED,
  }
  const queryName = isOpModel2(stationCode)
    ? 'setArrayContactors2'
    : 'setArrayContactors'
  return (
    <CommandModalTemplate
      ids={ids}
      setShowCommandModal={setShowCommandModal}
      modalTitles={modalTitles}
      defaultFormValues={defaultFormValues}
      CommandResultJsx={commandResultJsx}
      UserInputFormJsx={userInputFormJsx}
      queryName={queryName}
    />
  )
}
